export const SET_REGISTER_DATA = 'UPDATE REGISTER DATA'
export const CLEAR_REGISTER_DATA = 'CLEAR REGISTER DATA'